import styled, {css} from 'styled-components';
import {op} from '../../../../assets/symbols/symbols/Symbols.css';
import {BGImageCenter, ellipsis, ellipsisLines, mediumScreen} from '../../../../globalVariables/GlobalVariables';
import {dFlexCenter, dFlexColumn, flexColumn, justifyEnd} from '../../../../globalVariables/GlobalFlex';
import {getToken, getPrimitive, getSpacing, getFontSize, getFontWeight} from '@tickchak/react-share/app';
import zIndex from '../../../../globalVariables/zIndex';

export const row = styled.div`
    width: 100%;
    max-width: 100%;
    height: 100px;
    cursor: pointer;
    display: grid;
    grid-template-columns: 100px 1fr 150px 150px 70px 370px;
    grid-template-rows: 1fr;
    align-items: center;
    transition: all 300ms;
    &:hover:has(.editIcon) {
        .editIcon {
            visibility: visible;
            opacity: 1;
        }
        .progress {
            visibility: hidden;
            opacity: 0;
        }
    }
    @media screen and (max-width: ${mediumScreen}px) {
        grid-template-columns: 100px 1fr 150px 150px 70px 320px;
    }
`;

export const cssSubscriptionColumns = css`
    gap: 10px;
    .defaultColumn{
        width: max-content;
        padding-inline-end: 10px;
    }
    .firstColumn{
        position: unset;
    }
    .subscriptionType{
        padding-inline-start: 20px;
    }
    .activeColumn{
        position: absolute;
        inset-inline-end: 150px;
    }
`;

export const options = styled.div`
    width: 30px;
    height: 20px;
    cursor: pointer;
    ${BGImageCenter(op)}
    ${dFlexCenter}
`;

export const subscriptionOptionsListRoot = styled.div<{$anchorTop: number; $anchorInlineEnd: number}>`
    position: fixed;
    top: ${p => p.$anchorTop}px;
    inset-inline-end: ${p => p.$anchorInlineEnd}px;
    width: 0;
    height: 0;
    z-index: ${zIndex.dropDown};
`;

export const detail = styled.div`
    ${dFlexCenter}
    ${flexColumn}
    gap: ${getSpacing('spaceXs')};
    height: 100%;
    border-inline-end: 0.5px solid ${getPrimitive('blackAlphas.black05')};
    padding-inline: ${getSpacing('spaceSm')};
    grid-row: 1;

    &.saleValidity {
        grid-column: 3;
    }
    &.priceRange {
        grid-column: 4;
    }
    &.sales {
        grid-column: 5;
    }
`;

export const value = styled.div`
    font-weight: ${getFontWeight('semibold')};
    color: ${getToken('color.text.default')};
    ${ellipsis}
`;

export const label = styled.div`
    font-size: ${getFontSize('caption')};
    color: ${getToken('color.text.secondary')};
    ${ellipsis}
`;

export const associateEvents = styled.div`
    ${dFlexCenter}
    ${justifyEnd}
    gap: ${getSpacing('spaceLg')};
    height: 100%;
    padding-inline: ${getSpacing('spaceLg')};
    grid-column: 6;
    grid-row: 1;
`;

export const seriesInfo = styled.div`
    ${dFlexColumn}
    ${justifyEnd}
    gap: ${getSpacing('spaceSm')};
    position: relative;
    padding: ${getSpacing('spaceMd')} ${getSpacing('spaceSm')};
    grid-column: 2;
    grid-row: 1;
    height: 100%;
    border-inline-end: 0.5px solid ${getPrimitive('blackAlphas.black05')};
    padding-inline-start: ${getSpacing('spaceXl')};
`;
export const seriesTitle = styled.div`
    font-weight: ${getFontWeight('bold')};
    ${ellipsisLines(2)}
    font-size: ${getFontSize('body')};
`;
export const counts = styled.span <{margin?: string}>`
    margin-inline-start: ${p=>p.margin ? p.margin : getSpacing('spaceSm')};
    color: ${getPrimitive('solids.white')};
    background-color: ${getPrimitive('reds.red400')};
    padding-inline: ${getSpacing('spaceSm')};
    border-radius: var(--radius-lg);
`;
